import { render, staticRenderFns } from "./addBankCardResult.vue?vue&type=template&id=b4f2b968&scoped=true"
import script from "./addBankCardResult.vue?vue&type=script&lang=js"
export * from "./addBankCardResult.vue?vue&type=script&lang=js"
import style0 from "./addBankCardResult.vue?vue&type=style&index=0&id=b4f2b968&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f2b968",
  null
  
)

export default component.exports